import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useOrdemComprasEntregaFilters
 */

type State = {
  centroCusto: number[] | null;
  fornecedor: number[] | null;
  coletaPreco: number[] | null;
  ordemCompra: number[] | null;
  produtoServico: number[] | null;
  status: number[] | null;
  statusNF: number;
  nroNotaFiscal: string | null;
  dataOCStart: Date | null;
  dataOCEnd: Date | null;
};

export const initialOrdemComprasEntregaFilters: State = {
  centroCusto: null,
  fornecedor: null,
  coletaPreco: null,
  ordemCompra: null,
  produtoServico: null,
  status: [2, 4, 6],
  statusNF: 1,
  nroNotaFiscal: null,
  dataOCStart: null,
  dataOCEnd: null,
}

export const useOrdemComprasEntregaFilters = create<State>((set) => ({
  ...initialOrdemComprasEntregaFilters,
}));